import { render, staticRenderFns } from "./OrderDetailTab.vue?vue&type=template&id=5290b69f"
import script from "./OrderDetailTab.vue?vue&type=script&lang=js"
export * from "./OrderDetailTab.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailTab.vue?vue&type=style&index=0&id=5290b69f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports